<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <app-breadcrumb
                [title]="'Suivi des opérations'"
                [active_item]="'file d \'attente'"
            ></app-breadcrumb>
            <div class="card">
                <div class="card-body">
                    <div [hidden]="!initialView">
                        <div style="margin-top: -2rem !important">
                            <app-patrimoine-header
                                [displayDate]="false"
                                [count]="listTransactions"
                                [total]="totalRecords"
                                [legendePluriel]="
                                    'dossiers en attente de clôture'
                                "
                                [legendeSingulier]="
                                    'dossier en attente de clôture'
                                "
                            >
                            </app-patrimoine-header>
                        </div>
                        <div class="row filter_wrapper">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>Type demande</b>
                                    </label>
                                    <p-dropdown
                                        [options]="listOperations"
                                        [showClear]="true"
                                        [(ngModel)]="selectedOperation"
                                        placeholder="Type Demande"
                                    >
                                        <ng-template let-data pTemplate="item">
                                            <div class="country-item">
                                                <div>
                                                    {{ data | titlecase }}
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>N° Dossier</b>
                                    </label>
                                    <input
                                        placeholder="Demande"
                                        [(ngModel)]="selectedTransaction"
                                        type="text"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <!-- <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>IMSI</b>
                                    </label>
                                    <input
                                        placeholder="IMSI"
                                        [(ngModel)]="selectedimsi"
                                        type="text"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>
                                        <b>MSISDN</b>
                                    </label>
                                    <input
                                        placeholder="MSISDN"
                                        [(ngModel)]="selectedSim"
                                        type="text"
                                        pInputText
                                    />
                                </div>
                            </div> -->
                            <div class="col-md-2">
                                <label class="block"><b>Demandeur</b></label>
                                <p-dropdown
                                    [options]="listUsers"
                                    [(ngModel)]="currentUser"
                                    optionLabel="fullName"
                                    optionValue="id"
                                    [filter]="true"
                                    filterBy="fullName"
                                    [showClear]="true"
                                    placeholder="demandeur"
                                >
                                    <ng-template let-data pTemplate="item">
                                        <div class="country-item">
                                            <div>{{ data.fullName }}</div>
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                            <div class="col-md-2">
                                <label class="block"><b>Date début</b></label>
                                <p-calendar
                                    [(ngModel)]="filterDateStart"
                                    [showIcon]="true"
                                    (ngModelChange)="changeDateStart($event)"
                                    dateFormat="dd-mm-yy"
                                    [showButtonBar]="true"
                                ></p-calendar>
                            </div>
                            <div class="col-md-2">
                                <label class="block"><b>Date fin </b></label>
                                <p-calendar
                                    [(ngModel)]="filterDateEnd"
                                    [showIcon]="true"
                                    [showClear]="true"
                                    (ngModelChange)="changeDateEnd($event)"
                                    dateFormat="dd-mm-yy"
                                    [showButtonBar]="true"
                                ></p-calendar>
                            </div>
                            <div
                                class="p-0"
                                [ngStyle]="{ width: '4rem' }"
                                *ngIf="!secondFilter"
                            >
                                <label [ngStyle]="{ opacity: '0' }"
                                    >Actions</label
                                >
                                <br />
                                <p-button
                                    styleClass="p-button-success"
                                    icon="pi pi-filter"
                                    (click)="onFilter()"
                                    [disabled]="isFilter()"
                                ></p-button>
                            </div>
                        </div>
                        <hr />
                        <div class="table_content_wrapper">
                            <div class="table_actions_wrapper pt-2">
                                <button
                                    pButton
                                    pRipple
                                    label="Rafraîchir"
                                    (click)="OnRefresh()"
                                    icon="pi pi-refresh"
                                    class="p-button-secondary"
                                ></button>
                                <button
                                    pButton
                                    pRipple
                                    label="Exporter"
                                    (click)="OnExportExcel()"
                                    icon="pi pi-download"
                                    [disabled]="disableAction()"
                                    class="p-button-helf"
                                ></button>
                            </div>
                            <div class="d-flex gap-3">
                                <div class="table_header__legende">
                                    <app-table-header
                                        [count]="listTransactions"
                                        [legende]="'demandes'"
                                        [page]="page"
                                        [totalPage]="totalPage"
                                    ></app-table-header>
                                </div>
                            </div>
                            <table [ngClass]="['native_table table']">
                                <thead>
                                    <th class="text-center">#</th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '12rem' }"
                                    >
                                        Date / Heure
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '16rem' }"
                                    >
                                        Type Opération
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '12rem' }"
                                    >
                                        N° Dossier
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '10rem' }"
                                    >
                                        # Cycles
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '10rem' }"
                                    >
                                        # Lignes
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '4rem' }"
                                    >
                                        Etape
                                    </th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '4rem' }"
                                    >
                                        Etat
                                    </th>
                                    <th class="text-center">Demandeur</th>
                                    <th
                                        class="text-center"
                                        [style]="{ width: '3rem' }"
                                    >
                                        Actions
                                    </th>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let dossier of listTransactions
                                                | paginate
                                                    : {
                                                          itemsPerPage:
                                                              recordsPerPage,
                                                          currentPage: p,
                                                          totalPages: totalPage,
                                                          totalItems:
                                                              totalRecords
                                                      };
                                            let i = index
                                        "
                                    >
                                        <td>{{ this.offset + i }}</td>
                                        <td class="text-center">
                                            {{ dossier.created_at }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                getTitleForm(dossier?.operation)
                                            }}
                                        </td>
                                        <td
                                            class="text-center"
                                            (click)="
                                                copyTransaction(
                                                    dossier.numero_demande
                                                )
                                            "
                                            style="
                                                text-align: center;
                                                cursor: pointer;
                                            "
                                        >
                                            {{ dossier.numero_demande }}
                                        </td>
                                        <td class="text-center">
                                            {{ dossier?.nb_cycle }}
                                        </td>
                                        <td class="text-center">
                                            {{ dossier?.nb_demande_soumises }}
                                        </td>
                                        <td
                                            class="text-center"
                                            [style]="{ width: '3rem' }"
                                        >
                                            <span
                                                [ngStyle]="{
                                                    'font-size': '16px'
                                                }"
                                                [class]="
                                                    'badge ' +
                                                    getEtapeBadge(dossier)
                                                "
                                            >
                                                {{ dossier?.statut }}
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <span
                                                [ngStyle]="{
                                                    'font-size': '16px'
                                                }"
                                                [class]="
                                                    'badge ' +
                                                    getEtatBadge(dossier)
                                                "
                                            >
                                                {{
                                                    dossier.traitement ===
                                                    BADGE_ETAT?.COMPLET
                                                        ? 'complet'
                                                        : dossier.traitement
                                                }}
                                            </span>
                                        </td>
                                        <td>
                                            {{ dossier?.demandeur_nom }}
                                            {{ dossier?.demandeur_prenoms }}
                                        </td>
                                        <td class="td-actions">
                                            <button
                                                pButton
                                                pRipple
                                                label="Voir"
                                                icon="pi pi-eye"
                                                class="p-button-dark"
                                                (click)="
                                                    OnShowTraitement(dossier)
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div [ngClass]="['pagination-controls']">
                                <pagination-controls
                                    (pageChange)="onPageChange($event)"
                                    previousLabel=""
                                    nextLabel=""
                                >
                                </pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="progress-spinner" *ngIf="IsLoading">
    <p-progressSpinner
        [style]="{ width: '70px', height: '70px' }"
        strokeWidth="5"
        styleClass="spinner"
    ></p-progressSpinner>
</div>
